exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-7259d3e2],.fade-leave-active[data-v-7259d3e2]{-webkit-transition:opacity .25s ease;transition:opacity .25s ease}.fade-enter[data-v-7259d3e2],.fade-leave-to[data-v-7259d3e2]{opacity:0}.loader[data-v-7259d3e2]{left:16.25%;top:0;position:fixed;height:100%;width:83.75%;-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f2f2f2;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:10000}.mobileStyle[data-v-7259d3e2]{left:0!important;width:100%!important}.loaderContent[data-v-7259d3e2]{position:absolute;color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7259d3e2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/util/PageLoader.vue
// module id = 365
// module chunks = 0